import metadata from './data/munic-ibge-metadata.json';
import type { IssMunicIbgeDataVersion } from './munic-ibge-types.js';

export const ISS_MUNIC_IBGE_DATA_VERSION = metadata as IssMunicIbgeDataVersion;
